module.exports = __webpack_public_path__ + "img/assistance_login_alexa.11d2d065.jpg";